/**
 * Normalize a populated ref, ObjectId-like value, or raw id to a string.
 * @param {unknown} ref
 * @returns {string} empty string when there is no id
 */
export function schedulingRefId(ref) {
  if (ref == null || ref === "") return "";
  if (typeof ref === "object") {
    const id = ref._id ?? ref.id;
    return id != null && id !== "" ? String(id) : "";
  }
  return String(ref);
}

/**
 * @param {{ coachId?: unknown } | null | undefined} record bookable event or coach blackout
 * @param {{ _id?: unknown, id?: unknown } | null | undefined} activeUser
 * @returns {boolean}
 */
export function canManageSchedulingRecord(record, activeUser) {
  const ownerId = schedulingRefId(record?.coachId);
  // Shapes without an owner id fall back to API enforcement.
  if (!ownerId) return true;
  const viewerId = schedulingRefId(activeUser?._id ?? activeUser?.id);
  return viewerId !== "" && ownerId === viewerId;
}
